import { CircularProgress, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import CustomConfirmation from "../../components/GeneralComponents/CustomConfirmation";
import CustomDrawer from "../../components/GeneralComponents/CustomDrawer";
import CustomMUITable from "../../components/GeneralComponents/CustomMUITable/CustomMUITable";
import {
  _get_shipping_price,
  _delete_shipping_price,
} from "../../DAL/shipping_price/shipping_price";
import AddOrUpdateShipmentPrices from "../../components/ShippingPrices/AddOrUpdateShipmentPrices";
import { useContentSetting } from "../../Hooks/ContentContext/ContentSettingState";
import NoAccessData from "../../components/GeneralComponents/NoAccessData";

const TABLE_HEAD = [
  { id: "number", label: "#", alignRight: false, type: "number" },
  { id: "state_name", label: "State", alignRight: false },
  { id: "shippingPrice", label: "Shipping Charges", alignRight: false },
  { id: "taxRate", label: "Tax Rate", alignRight: false },
  { id: "action", label: "Action", alignRight: false, type: "action" },
];

export default function ShipmentPrices() {
  const { privilegeAccess, userInfo } = useContentSetting();
  const [drawerState, setDrawerState] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [anchorEl, setAnchorEl] = useState(null);
  const [formType, setFormType] = useState("ADD");
  const [selectedRow, setSelectedRow] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [shippingPrices, setShippingPrices] = useState([]);

  const handleAgreeDelete = (value) => {
    // setDeleteValue(value._id);
    setSelectedRow(value);
    setOpenDelete(true);
    handleCloseMenu();
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleEdit = (value) => {
    setSelectedRow(value);
    setDrawerState(true);
    setFormType("EDIT");
  };
  const handleOpenDrawer = () => {
    if (userInfo.type == 2) {
      if (privilegeAccess.add_shipment_prices === true) {
        setDrawerState(true);
        setFormType("ADD");
      }
    } else {
      setDrawerState(true);
      setFormType("ADD");
    }
  };
  const handleOpenEditDrawer = () => {
    // setEditDrawerState(true);
  };
  const handleCloseEditDrawer = () => {
    setDrawerState(false);
  };

  const get_shipping_prices_list = async () => {
    const response = await _get_shipping_price();
    if (response.code === 200) {
      let data = response.shipping_price.map((shipping) => {
        return {
          ...shipping,
          shippingPrice: "$" + shipping.shipping_price,
          taxRate: shipping.tex_rate + "%",
        };
      });
      setShippingPrices(data);
      setIsLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
      is_access:
        userInfo.type == 0 ? true : privilegeAccess.edit_shipment_prices,
    },

    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
      is_access:
        userInfo.type == 0 ? true : privilegeAccess.delete_shipment_prices,
    },
  ];

  const handleDelete = async () => {
    setOpenDelete(false);
    const response = await _delete_shipping_price(selectedRow._id);
    if (response.code == 200) {
      enqueueSnackbar(response.message, {
        variant: "success",
      });

      setShippingPrices((prevData) =>
        prevData.filter((shipping) => shipping._id !== selectedRow._id)
      );
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  useEffect(() => {
    get_shipping_prices_list();
  }, []);

  if (isLoading) {
    return (
      <div className="circular-progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <div className="container">
      <CustomDrawer
        isOpenDrawer={drawerState}
        onOpenDrawer={handleOpenEditDrawer}
        onCloseDrawer={handleCloseEditDrawer}
        pageTitle={`${formType === "ADD" ? "Add" : "Edit"} Rate`}
        componentToPassDown={
          <>
            <AddOrUpdateShipmentPrices
              onCloseDrawer={handleCloseEditDrawer}
              isOpenDrawer={drawerState}
              formType={formType}
              setShippingPrices={setShippingPrices}
              shippingPrices={shippingPrices}
              selectedRow={selectedRow}
              apiFunction={get_shipping_prices_list}
            />
          </>
        }
      />

      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete this Shipping Price?"}
        handleAgree={handleDelete}
      />

      <div className="row mb-4">
        <div className="col-lg-8 col-sm-12 mt-3">
          <h3>Shipping & Tax Rates</h3>
        </div>
        <div className="col-lg-4 col-sm-12 text-end">
          <Tooltip
            title={
              userInfo.type == 2 &&
              privilegeAccess.add_shipment_prices === false
                ? "You have no access to perform this action"
                : ""
            }
            placement="right-end"
            arrow
          >
            <button
              className="small-contained-button"
              onClick={handleOpenDrawer}
            >
              Add Rates
            </button>
          </Tooltip>
        </div>
      </div>
      {userInfo.type == 2 && !privilegeAccess.view_shipment_prices ? (
        <NoAccessData />
      ) : (
        <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          data={shippingPrices}
          className="card-with-background"
          MENU_OPTIONS={MENU_OPTIONS}
        />
      )}
    </div>
  );
}
